// src/sections/Drinks/Drinks.js
import React from 'react';
import styles from './Drinks.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';

const drinksData = {
  // Colonne 1: SPÉCIAL (Freeze et Mogu Mogu)
  special: [
    { id: "drink-freeze-generic", name: "FREEZE (Saveurs selon arrivage)", price: "3.00€" },
    { id: "drink-freeze-example1", name: "Ex: BLUE HAWAÏ", price: "" },
    { id: "drink-freeze-example2", name: "Ex: PIÑA COLADA", price: "" },
    { id: "drink-mogu-generic", name: "MOGU MOGU (Saveurs selon arrivage)", price: "3.00€" },
    { id: "drink-mogu-example1", name: "Ex: LITCHI", price: "" },
    { id: "drink-mogu-example2", name: "Ex: PASTÈQUE", price: "" },
  ],
  // Colonne 2: Sodas
  sodas: [
    { id: "drink-icetea", name: "ICE TEA PÊCHE (33 CL)", price: "2.50€" },
    { id: "drink-orangina", name: "ORANGINA (33 CL)", price: "2.50€" },
    { id: "drink-coca", name: "COCA-COLA (33 CL)", price: "2.50€" },
    { id: "drink-coca-zero", name: "COCA-COLA ZÉRO (33 CL)", price: "2.50€" },
  ],
  // Colonne 3: Eaux (y compris Cristaline aux fruits)
  eaux: [
    { id: "drink-cristaline-50", name: "CRISTALINE (50 CL)", price: "1.50€" },
    { id: "drink-cristaline-gazeuse", name: "CRISTALINE GAZEUSE (50 CL)", price: "2.50€" },
    { id: "drink-cristaline-fruits-citronnade", name: "CRISTALINE FRUITS (Citronnade)", price: "2.00€" },
    { id: "drink-cristaline-fruits-the-vert-menthe", name: "CRISTALINE FRUITS (Thé vert menthe)", price: "2.00€" },
    { id: "drink-cristaline-fruits-peche", name: "CRISTALINE FRUITS (Pêche)", price: "2.00€" },
    { id: "drink-cristaline-fruits-fraise", name: "CRISTALINE FRUITS (Fraise)", price: "2.00€" },
  ]
};

const Drinks = ({ id, favorites, addFavorite, removeFavorite }) => {

  const isFavorite = (item) => {
    // Vérifie si l'item a un ID avant de tenter de le comparer
    return item.id && favorites.some(favItem => favItem.id === item.id);
  };

  const handleFavoriteClick = (item) => {
    // S'assure qu'on ne tente pas d'ajouter/retirer un favori si l'item n'a pas de prix (ex: "Ex: Saveur")
    if (item.price) {
      if (isFavorite(item)) {
        removeFavorite(item.id);
      } else {
        addFavorite(item);
      }
    }
  };

  return (
    <section id={id} className={styles.drinks}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>BOISSONS</h2>

        <div className={styles.drinksGrid}>
          {/* Colonne 1: SPÉCIAL */}
          <div className={styles.drinksColumn}>
            <h3 className={styles.categoryTitle}>SPÉCIAL</h3>
            {drinksData.special.map((item) => (
              <div key={item.id} className={styles.menuItem}>
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemSeparator}></span>
                <div className={styles.priceAndFavorite}>
                  <span className={styles.itemPrice}>{item.price}</span>
                  {item.price && ( // Afficher le bouton favori uniquement si un prix est présent
                    <button
                      className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                      onClick={() => handleFavoriteClick(item)}
                      aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                    >
                      <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Colonne 2: Sodas */}
          <div className={styles.drinksColumn}>
            <h3 className={styles.categoryTitle}>SODAS</h3>
            {drinksData.sodas.map((item) => (
              <div key={item.id} className={styles.menuItem}>
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemSeparator}></span>
                <div className={styles.priceAndFavorite}>
                  <span className={styles.itemPrice}>{item.price}</span>
                  <button
                    className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                    onClick={() => handleFavoriteClick(item)}
                    aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                  >
                    <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Colonne 3: Eaux */}
          <div className={styles.drinksColumn}>
            <h3 className={styles.categoryTitle}>EAUX</h3>
            {drinksData.eaux.map((item) => (
              <div key={item.id} className={styles.menuItem}>
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemSeparator}></span>
                <div className={styles.priceAndFavorite}>
                  <span className={styles.itemPrice}>{item.price}</span>
                  <button
                    className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                    onClick={() => handleFavoriteClick(item)}
                    aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                  >
                    <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Drinks;